<template>
  <div class="Orders">
    <div class="container">
      <!-- Content here -->
      <br />
      <nav class="navbar navbar-light bg-light">
        <span class="navbar-brand mb-0 h1">委託代買幫訂單</span>
      </nav>

      <div class="card">
        <div class="card-body">
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(0)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            <b>尚未評估委託單</b>
            <span class="badge_order badge bg-secondary">{{
              statusCount0
            }}</span>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(1)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            <b>尚未付款委託單</b>
            <span class="badge_order badge bg-secondary">{{
              statusCount1
            }}</span>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(2)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            <b>已付款委託單</b>
            <span class="badge_order badge bg-secondary">{{
              statusCount2
            }}</span>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(10)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            <b>1688出貨委託單</b>
            <span class="badge_order badge bg-secondary">{{
              statusCount10
            }}</span>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(11)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            <b>送至中國集運託單</b>
            <span class="badge_order badge bg-secondary">{{
              statusCount11
            }}</span>
          </b-button>
          <b-button
            variant="outline-info"
            @click="filterDisplaysButton(12)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            <b>出貨到台灣委託單</b>
            <span class="badge_order badge bg-secondary">{{
              statusCount12
            }}</span>
          </b-button>
          <!-- <b-button
            variant="outline-info"
            @click="filterDisplaysButton(13)"
            style="float: left; margin-right: 10px; margin-top: 5px"
          >
            
            <b>完成出貨委託單</b>
            <span class="badge_order bg-secondary">{{ statusCount13 }}</span>
          </b-button> -->
        </div>
      </div>

      <div v-if="displayViews != ''">
        <!-- conent -->
        <div
          v-for="(displayView, index) in filterDisplays"
          v-bind:key="(displayView, index)"
        >
          <div>
            <div class="list-group">
              <li
                class="mt-3 mb-3 list-group-item list-group-item-action flex-column align-items-start"
              >
                <div class="d-flex w-100 justify-content-between">
                  <small></small>
                </div>
                <!-- <input type="checkbox" class="checkbox_size" :value="displayView.key" v-model="checkboxedProds" /> -->
                <p class="mb-1">訂單編號:{{ displayView.key }}</p>
                <p class="mb-1">
                  <b>下單日期: {{ displayView.creat_date.split(' ')[0] }}</b>
                </p>

                <p class="mb-1">
                  <b>貨源供應商:</b>
                </p>
                <ul
                  class="list-group"
                  v-for="(venderInfo, index) in prodVenderComputed(
                    displayView.prod_infos,
                    displayView.key
                  )"
                  v-bind:key="(venderInfo, index)"
                >
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    {{ venderInfo.vender_name }}
                    <span class="badge badge-primary badge-pill"
                      ><div
                        v-if="
                          venderInfo.vender_status == undefined ||
                          venderInfo.vender_status == 0
                        "
                      >
                        等待出貨
                      </div>
                      <div v-if="venderInfo.vender_status == 1">
                        已經出貨
                      </div></span
                    >
                  </li>
                </ul>

                <hr size="10" />
                <div v-if="Array.isArray(displayView.prod_infos)">
                  <div
                    v-for="(
                      prod_infos, prodInfosIndex
                    ) in displayView.prod_infos"
                    v-bind:key="(prod_infos, prodInfosIndex)"
                  >
                    <p>商品名稱: {{ prod_infos.prod_name }}</p>
                    <a
                      v-bind:href="prod_infos.prod_url"
                      target="_blank"
                      title="阿里巴巴工廠連結"
                      >阿里巴巴工廠連結</a
                    >
                    <div v-if="prod_infos.color_image_selected">
                      <img
                        height="100"
                        width="100"
                        v-bind:src="prod_infos.color_image_selected"
                        referrerpolicy="no-referrer"
                      />
                    </div>
                    <p>選擇的顏色: {{ prod_infos.color_name_selected }}</p>
                    <div
                      v-for="(sku_info, skuInfoIndex) in prod_infos.sku_info"
                      v-bind:key="(sku_info, skuInfoIndex)"
                    >
                      <div v-if="sku_info.amount != 0">
                        <hr
                          style="
                            border-top: 1px dashed #cccccc;
                            height: 1px;
                            overflow: hidden;
                          "
                          size="10"
                        />
                        <p>款式: {{ sku_info.sku_name }}</p>
                        <p>數量: {{ sku_info.amount }}</p>
                        <hr
                          style="
                            border-top: 1px dashed #cccccc;
                            height: 1px;
                            overflow: hidden;
                          "
                          size="10"
                        />
                      </div>
                    </div>
                    <div v-if="prod_infos.prod_detail">
                      <div class="prod_detail">
                        商品注意事項: {{ prod_infos.prod_detail }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <p>商品名稱: {{ displayView.prod_infos.prod_name }}</p>
                  <div v-if="displayView.prod_infos.color_image_selected">
                    <img
                      height="100"
                      width="100"
                      v-bind:src="displayView.prod_infos.color_image_selected"
                      referrerpolicy="no-referrer"
                    />
                  </div>
                  <p>
                    選擇的顏色: {{ displayView.prod_infos.color_name_selected }}
                  </p>
                  <div
                    v-for="(sku_info, skuInfoIndex) in displayView.prod_infos
                      .sku_info"
                    v-bind:key="(sku_info, skuInfoIndex)"
                  >
                    <div v-if="sku_info.amount != 0">
                      <hr
                        style="
                          border-top: 1px dashed #cccccc;
                          height: 1px;
                          overflow: hidden;
                        "
                        size="10"
                      />
                      <p>款式: {{ sku_info.sku_name }}</p>
                      <p>數量: {{ sku_info.amount }}</p>
                      <hr
                        style="
                          border-top: 1px dashed #cccccc;
                          height: 1px;
                          overflow: hidden;
                        "
                        size="10"
                      />
                    </div>
                  </div>
                </div>

                <p
                  class="mb-1"
                  v-if="displayView.prod_total_infos != undefined"
                >
                  訂單重量: {{ displayView.prod_total_infos.prod_weight }} kg
                </p>
                <p class="mb-1" v-if="displayView.total_amount != undefined">
                  訂單商品總數: {{ displayView.total_amount }}
                </p>

                <div v-if="displayView.product_delivery == 'deliveryStore'">
                  <div
                    v-if="displayView.map_info.logistics_sub_type == 'FAMIC2C'"
                  >
                    <p class="mb-1">取貨超商:全家店到店</p>
                  </div>
                  <div
                    v-if="
                      displayView.map_info.logistics_sub_type == 'UNIMARTC2C'
                    "
                  >
                    <p class="mb-1">取貨超商:7-ELEVEN 超商交貨便</p>
                  </div>
                  <div
                    v-if="
                      displayView.map_info.logistics_sub_type == 'HILIFEC2C'
                    "
                  >
                    <p class="mb-1">取貨超商:萊爾富店到店</p>
                  </div>
                  <p class="mb-1">
                    取貨超商地址:{{ displayView.map_info.cvs_address }}
                  </p>
                  <p class="mb-1">
                    取貨超商:{{ displayView.map_info.cvs_store_name }}
                  </p>
                  <p class="mb-1">
                    取貨超商編號:{{ displayView.map_info.cvs_store_id }}
                  </p>
                </div>
                <div v-else>
                  <p class="mb-1">收貨地址:{{ displayView.address }}</p>
                </div>

                <p
                  class="mb-1"
                  v-if="
                    displayView.logistics_info &&
                    displayView.logistics_info.length != 0
                  "
                >
                  包稅選擇: {{ displayView.logistics_info.tax }}
                </p>
                <p class="mb-1">收貨姓名:{{ displayView.user_order_name }}</p>
                <p class="mb-1">電話:{{ displayView.user_phone }}</p>
                <p class="mb-1">客戶特別備註: {{ displayView.note }}</p>

                <div v-if="displayView.status == 0">
                  <b>
                    <h3>
                      <b-badge variant="primary">等待確認委託單</b-badge>
                    </h3>
                  </b>
                </div>
                <div v-if="displayView.status == 1">
                  <b>
                    <h3>
                      <b-badge variant="warning">確認委託單，等待付款</b-badge>
                    </h3>
                  </b>
                  <a
                    :href="
                      'https://purchaswebpage.firebaseapp.com/payv1.1?orderId=' +
                      displayView.key +
                      '&userId=' +
                      userId
                    "
                    class="pay-link"
                  >
                    前往付款
                  </a>
                </div>
                <div v-if="displayView.status == 2">
                  <h3>
                    <b-badge variant="info">已付款</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 10">
                  <h3>
                    <b-badge variant="info">阿里巴巴出貨</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 11">
                  <h3>
                    <b-badge variant="info">到中國集運</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 12">
                  <h3>
                    <b-badge variant="success">準備到台灣</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 13">
                  <h3>
                    <b-badge variant="success">出貨完成</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.status == 40">
                  <h3>
                    <b-badge variant="dark">訂單取消</b-badge>
                  </h3>
                </div>
                <div v-if="displayView.total == 0">
                  <p class="mb-1">
                    <b>付款金額: 等待工廠確認</b>
                  </p>
                </div>
                <div v-if="displayView.total != 0 && displayView.status > 0">
                  <p class="mb-1">
                    <b>付款金額: ${{ displayView.total }} 台幣</b>
                  </p>
                </div>
                <small></small>
              </li>
            </div>
          </div>
        </div>
        <!-- conent -->
        <!-- footer -->
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">總共:{{ orderCount }}訂單</p>
          </div>
        </div>
        <!-- footer -->
      </div>
      <div v-else>
        <div class="jumbotron jumbotron-fluid">
          <div class="container">
            <h1 class="display-4"></h1>
            <p class="lead">目前沒有任何訂單</p>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="false"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
.badge_order {
  color: white !important;
}

.P-logo {
  height: 100px;
  width: 100px;
}

.countdown {
  padding: 0px 10px;
}

.expiry_date {
  font-weight: bold;
}

.send_date {
  font-weight: bold;
}

.count_l1 {
  font-weight: bold;
}

.count_l2 {
  font-weight: bold;
}

.prod_detail {
  font-size: 10px;
  color: red;
}

.category_text {
  text-align: left;
  padding: 10px 0px;
}

.category_scrollview {
  overflow: hidden;
  width: auto;
  overflow-x: auto;
  white-space: nowrap;
}

.category_button {
  display: inline-block;
  padding: 0px 2px;
}

.card_button {
  padding: 10px 0px;
}

.card_contain {
  padding: 20px;
  width: 18rem;
}

.checkbox_size {
  zoom: 2;
  width: 20px;
  height: 20px;
}

.pay-link {
  color: green;
  font-size: 24px;
  font-weight: bold;
  text-decoration: underline;
  transition: color 0.2s;
}

.pay-link:hover {
  color: limegreen;
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'orders',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: true,
      userId: '',
      userImage: '',
      userName: '',
      categoryViews: '',
      displayViews: '',
      nowStatus: 0,
      checkUnChatbotSigninStatus: false,
      filterStatus: 0,
      filterDisplays: [],
      orderCount: 0,
      statusCount0: 0,
      statusCount1: 0,
      statusCount2: 0,
      statusCount10: 0,
      statusCount11: 0,
      statusCount12: 0,
      statusCount13: 0,
      statusCount40: 0,
    }
  },
  watch: {},
  computed: {},
  methods: {
    filterDisplaysButton: function (status) {
      const vm = this
      vm.filterStatus = status
      vm.filterDisplayViews()
    },
    filterDisplayViews: function () {
      const vm = this
      vm.isLoading = true
      vm.filterDisplays = []
      vm.statusCount0 = 0
      vm.statusCount1 = 0
      vm.statusCount2 = 0
      vm.statusCount10 = 0
      vm.statusCount11 = 0
      vm.statusCount12 = 0
      vm.statusCount13 = 0
      vm.statusCount40 = 0

      for (var object in vm.displayViews) {
        if (vm.displayViews[object].status == vm.filterStatus) {
          vm.filterDisplays.push(vm.displayViews[object])
          vm.orderCount = vm.filterDisplays.length
        }
        if (vm.displayViews[object].status == 0) {
          vm.statusCount0++
        }
        if (vm.displayViews[object].status == 1) {
          vm.statusCount1++
        }
        if (vm.displayViews[object].status == 2) {
          vm.statusCount2++
        }
        if (vm.displayViews[object].status == 10) {
          vm.statusCount10++
        }
        if (vm.displayViews[object].status == 11) {
          vm.statusCount11++
        }
        if (vm.displayViews[object].status == 12) {
          vm.statusCount12++
        }
        if (vm.displayViews[object].status == 13) {
          vm.statusCount13++
        }
        if (vm.displayViews[object].status == 40) {
          vm.statusCount40++
        }
      }
      if (vm.filterDisplays == '') {
        vm.$toast.open({
          message: '目前沒有訂單!',
          type: 'error',
        })
      } else {
        vm.$toast.open({
          message: '查詢成功!',
          type: 'success',
        })
      }
      vm.isLoading = false
      this.$forceUpdate()
    },
    checkUnChatbotSignin: function () {
      const vm = this
      if (!localStorage.userId) {
        this.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '關閉',
            },
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })

        vm.checkUnChatbotSigninStatus = true
        return true
      } else {
        vm.userName = localStorage.userName
        vm.checkUnChatbotSigninStatus = false
        return false
      }
    },
    queryOrderByUserId: function (userId) {
      const vm = this
      vm.isLoading = true
      vm.$toast.open({
        message: '查詢中!',
        type: 'success',
      })
      axios
        .post(vm.apiUrl + 'QueryOrderByUserId', {
          userId: userId,
        })
        .then(function (response) {
          if (response.data.length == 0) {
            // alert("系統錯誤請稍後再試");
            vm.$toast.open({
              message: '目前沒有訂單!',
              type: 'error',
            })
          } else {
            vm.displayViews = response.data
            vm.filterDisplayViews()
            vm.$toast.open({
              message: '查詢成功!',
              type: 'success',
            })
          }
          vm.isLoading = false
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          // console.log(response.data);
        })
        .catch(function (error) {
          alert(error)
          // console.log(error);
        })
    },
    prodVenderComputed: function (prodInfos, key) {
      const set = new Set()
      const result = prodInfos.filter(item =>
        !set.has(item.prod_vender) ? set.add(item.prod_vender) : false
      )
      let prodVenders = []
      let venderIndex = 0
      for (let prodInfos of result) {
        if (prodInfos.hasOwnProperty('prod_vender')) {
          let regex = /[^name=]*[$;]/g
          let prodvender = prodInfos.prod_vender.match(regex)
          if (prodvender == undefined) {
            prodvender = prodInfos.prod_vender
          } else {
            prodvender = prodvender[0].replace(';', '')
          }

          venderIndex++
          let id = key.substr(-3, key.length)
          let venderInfo = {
            vender_id:
              prodvender + ' ' + id + ' ' + result.length + '-' + venderIndex,
            vender_name: prodvender,
            vender_count: result.length,
            vender_index: venderIndex,
            vender_status: prodInfos.prod_vender_status,
          }
          prodVenders.push(venderInfo)
        } else {
          return 'no_data'
        }
      }
      console.log('prodVenders: ' + prodVenders)
      return prodVenders
    },
  },
  mounted() {
    const vm = this
    vm.isLoading = false

    try {
      if (vm.$route.query.userId) {
        localStorage.userId = decodeURI(vm.$route.query.userId)
      }
      if (vm.$route.query.tab !== undefined) {
        vm.filterStatus = Number(vm.$route.query.tab)
      }
      vm.userId = localStorage.userId
      vm.checkUnChatbotSignin()
      vm.queryOrderByUserId(localStorage.userId)
    } catch (e) {
      // console.info(e);
      alert(e)
    }
  },
}
</script>
